import React, { useState } from 'react';
import { AdminApiService } from '../../services/adminApiService';
import './AdminLogin.css';

interface AdminLoginProps {
  onLoginSuccess: () => void;
}

export const AdminLogin: React.FC<AdminLoginProps> = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const result = await AdminApiService.login(email, password);
      if (result.success) {
        // Verify token was saved
        const savedToken = AdminApiService.getToken();
        if (!savedToken) {
          setError('Failed to save admin token. Please try again.');
          setLoading(false);
          return;
        }
        // Small delay to ensure token is saved, then trigger success
        setTimeout(() => {
          onLoginSuccess();
        }, 100);
      } else {
        setError(result.error || 'Login failed');
        setLoading(false);
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'An unexpected error occurred');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h1>Admin Portal</h1>
        <p className="admin-login-subtitle">Migoyugo Administration</p>
        
        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="admin@example.com"
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="Enter your password"
            />
          </div>

          {error && <div className="admin-error-message">{error}</div>}

          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

